angular.module('pages.mypayments', [])
	.config(config);

config.$inject = ['$stateProvider'];
function config($stateProvider) {
	$stateProvider
		.state('pages.mypayments', {
			url: 'mypayments',
			template: require('./templates/index.html'),
			controller: require('./controllers/mypayments'),
			data: {
				restricted: true
			}

		})
}

module.exports = 'pages.mypayments';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myPayments/index.js
 ** module id = 277
 ** module chunks = 1
 **/